import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=39c1a74f&scoped=true&"
import script from "./BottomNavigation.vue?vue&type=script&lang=js&"
export * from "./BottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=39c1a74f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1a74f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c1a74f')) {
      api.createRecord('39c1a74f', component.options)
    } else {
      api.reload('39c1a74f', component.options)
    }
    module.hot.accept("./BottomNavigation.vue?vue&type=template&id=39c1a74f&scoped=true&", function () {
      api.rerender('39c1a74f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BottomNavigation.vue"
export default component.exports